import { Controller } from '@hotwired/stimulus';

import { apply } from '@/modules/mask';

export default class extends Controller {
  connect() {
    apply(this.element, { mask: '00.000.000/0000-00' });
  }
}
